// eslint-disable-next-line import/prefer-default-export
import { createSelector } from 'reselect';

export const getProject = ({ project }) => project.data;
export const getProjectsLoading = ({ project }) => project.loading;
export const getProjectSelectedDataIds = ({ project }) => ({
  selectedProjectImageIds: project.selectedImageIds,
  selectedProjectItemIds: project.selectedItemIds,
  selectedProjectSetIds: project.selectedSetIds,
  selectedProjectColorIds: project.selectedColorIds,
});

export const getProjectSelectedData = createSelector(
  getProject,
  getProjectSelectedDataIds,
  (data, {
    selectedProjectImageIds,
    selectedProjectItemIds,
    selectedProjectSetIds,
    selectedProjectColorIds,
  }) => {
    if (!data) {
      return {
        selectedProjectImages: [],
        selectedProjectItems: [],
        selectedProjectColors: [],
        selectedProjectSets: [],
      };
    }
    const {
      images = [], items = [], sets = [], colors = [],
    } = data;

    return {
      selectedProjectImages: images.filter(({ id }) => selectedProjectImageIds.includes(id)),
      selectedProjectItems: items.filter(({ id }) => selectedProjectItemIds.includes(id)),
      selectedProjectColors: colors.filter(({ id }) => selectedProjectColorIds.includes(id)),
      selectedProjectSets: sets.filter(({ id }) => selectedProjectSetIds.includes(id)),
    };
  },
);
